import { useEffect, useState } from "react";
import { apiFetch } from "./api";

// Parámetros del sistema que el administrador cambia desde Configuración → Parámetros (IVA, plazo del crédito…).
// Se cargan una vez al entrar; mientras no lleguen (o si el servidor aún no los tiene) se usan los valores de siempre.
const DEFECTOS = {
  iva_porcentaje: 15,
  plazo_credito_dias: 30,
  max_cotizaciones_por_producto: 3,
};

let valores = { ...DEFECTOS };
let cargados = false;
const oyentes = new Set();

export async function cargarParametros() {
  try {
    const datos = await apiFetch("/api/parametros/valores");
    valores = { ...DEFECTOS, ...datos };
    cargados = true;
    oyentes.forEach((avisar) => avisar());
  } catch {
    // Sin conexión o sin sesión: se siguen usando los valores de siempre.
  }
}

export const parametro = (clave) => valores[clave] ?? DEFECTOS[clave];
export const ivaPorcentaje = () => parametro("iva_porcentaje");
export const ivaFraccion = () => ivaPorcentaje() / 100;

// Para pantallas que deben repintarse cuando llegan los valores (si se abrieron antes de que terminara la carga).
export function useParametros() {
  const [, repintar] = useState(0);
  useEffect(() => {
    const avisar = () => repintar((n) => n + 1);
    oyentes.add(avisar);
    if (!cargados) cargarParametros();
    return () => oyentes.delete(avisar);
  }, []);
  return valores;
}
